export enum AppTheme {
  default = 'default',
  white = 'white'
}